import PropTypes from 'prop-types';
import React from 'react';
import styles from './work-description.css';
import closeImg from './close.png'
import {injectIntl} from "react-intl";

const WorkDescriptionComponent = function (props) {
    const {
        onClose,
        workInfo,
        workDescription,
    } = props;

    const windowWidth = window.innerHeight;
    // console.log(windowWidth, '00000000000', windowWidth - windowWidth*3/4, windowWidth*3/4);

    return (
        <div className={styles.box}>
            <div className={styles.main}
                 style={{
                     height:windowWidth * 3 / 4
                 }}

            >
                <div className={styles.close}>
                    <img src={closeImg} alt="" onClick={onClose}/>
                </div>
                <div className={styles.mainBox}>
                    {
                        workInfo.description ? <p className={styles.title}>作品简介：</p> : null
                    }
                    {
                        workInfo.description ? <div className={styles.card}>
                            <p className={styles.cardTest}>{workInfo.description}</p>
                        </div> : null
                    }

                    {
                        workInfo.manual ? <p className={styles.title}>操作说明：</p> : null
                    }

                    {
                        workInfo.manual ?
                            <div className={styles.card}><p className={styles.cardTest}>{workInfo.manual}</p>
                            </div> :
                            null
                    }
                </div>
            </div>
        </div>
    )
};


WorkDescriptionComponent.propTypes = {
    onClose: PropTypes.func,
    workInfo: PropTypes.object,
    workDescription: PropTypes.object,
};

export default injectIntl(WorkDescriptionComponent);
